import axios from 'axios';
import { PRICE_VERSION_VARIATION_ENDPOINT } from '../../../common/endpoints';

export async function updateVersionPivot(row) {
  const datamasterId = row.datamasterId
  const reference = row.pivotReferences.find((pivotReference) => pivotReference.id === row.selectedNewPivot)
  const body = {
    priceVersion: row.price,
    priceReference: reference.price,
    year: row.year,
    referenceId: reference.id,
    modelId: row.modelId
  }

  try{
      return await axios.put(`${PRICE_VERSION_VARIATION_ENDPOINT}/reference/${datamasterId}`, body)
  }catch(error){
      console.log(error)
      throw new Error(error)
  }
}